import { combineEpics } from 'redux-observable';
import CreateContainerEpics from '../components/CreateContainer/CreateContainer.epics';
export const rootEpic = combineEpics(CreateContainerEpics);

//# sourceMappingURL=index.js.map
